var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "circular-cancel-modal",
      staticClass: "ecircular-modal",
      attrs: {
        modalId: _vm.modalId,
        modalType: "small-modal",
        showCloseBtn: false,
      },
    },
    [
      _c(
        "p",
        {
          staticClass: "font-bold",
          attrs: { slot: "modal-header" },
          slot: "modal-header",
        },
        [_vm._v(_vm._s(_vm.$t("hint.cancelECircular")))]
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _c(
          "button",
          {
            staticClass: "btn--orange",
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("action.no")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn--darkblue",
            on: {
              click: function ($event) {
                return _vm._cancelECircular()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("action.yes")))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }